/* Local Shopify CLI plumbing: retain the development origin for shop-owned links. */
(() => {
  if (!['127.0.0.1', 'localhost'].includes(location.hostname)) return;
  if (window.Shopify?.theme?.role !== 'development') return;
  const shopHosts = new Set(['www.boxtoheart.com', 'boxtoheart.com', 'boxtoheart.myshopify.com']);
  const normalize = root => {
    const anchors = root.matches?.('a[href]') ? [root] : root.querySelectorAll?.('a[href]') || [];
    for (const anchor of anchors) {
      const raw = anchor.getAttribute('href');
      if (!raw || !/^https?:\/\//i.test(raw)) continue;
      try {
        const url = new URL(raw);
        if (shopHosts.has(url.hostname)) anchor.setAttribute('href', url.pathname + url.search + url.hash);
      } catch { /* Preserve an invalid legacy link for inspection. */ }
    }
  };
  normalize(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) normalize(node);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
